import { gspx } from '@rsos/capstone';

export const trackShareButtonClick = (irpVersion) => {
  gspx.trackCustomEvent('ASC', {
    Category: 'ASC',
    irpVersion,
    'Launched date': new Date(),
    name: 'User clicks on ASC share button in 911 event',
  });
};
